<template>
    <!-- List Contacts Page -->
    <div class="page-layout blank contacts-manage">
        <div class="pb-15 pr-3 pl-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <!-- Breadcrumb Section -->
                <div class="breadcrumbnew">
                    <span>Customers</span>
                    <a>List View</a>
                </div>
                <!--eader Buttons Section -->
                <div class="d-flex flex-wrap align-items-center margin987">
                    <!-- <button class="btn btn-new-primary btn-wide px-6 mr-4" @click="$modal.show('columnConfigCustomers')"><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/column-config.svg" style="margin-right: 8px; margin-top: -2px"> Column Config</button> -->
                    <button class="btn btn-new-primary btn-wide px-6 mr-4" v-if="archieveButton && userPermissions.customers.permitted_actions.archive" :disabled="selected_data.length < 1" :style="selected_data.length ? '' : 'background-color: #ababab; border-color: #ababab'" @click="selected_data.length ? $modal.show('archiveModal') : ''"><i class="icon icon-arrow-down-bold-box text-white mr-2 fs-18"></i>Archive</button>
                    <button class="btn btn-new-primary btn-wide px-6 mr-4" v-if="active_tab == 'archieve' && userPermissions.customers.permitted_actions.retrieve" :disabled="selected_data.length < 1" :style="selected_data.length ? '' : 'background-color: #ababab; border-color: #ababab'" @click="selected_data.length ? $modal.show('archiveModal'): ''"><i class="icon icon-arrow-down-bold-box text-white mr-2 fs-18"></i>Retrieve</button>
                    <button class="btn btn-new-primary btn-wide px-6 mr-4" @click="showFilters()"><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px;"> Filter</button>
                    <button class="btn btn-new-primary btn-wide px-6 mr-4 margin499" disabled><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/export-excel-white.svg" style="margin-right: 8px; margin-top: -2px"> Export to Excel</button>
                    <button class="btn btn-new-danger btn-wide px-6 mr-4 margin620" v-if="(loggedInUser.user_role == 'sales_manager' && userPermissions.customers.permitted_actions.delete)" :disabled="selected_data.length < 1" :style="selected_data.length  ? '' : 'background-color: #ababab; border-color: #ababab'" @click="selected_data.length ? $modal.show('deleteCustomer') : ''">- Delete</button>
                    <button class="btn btn-new-green btn-wide px-6 margin763" v-if="userPermissions.customers.permitted_actions.create && loggedInUser.user_role != 'generic_user'"  @click="$router.push('/create_customer/new')">+ Create New</button>
                </div>
            </div>
            <!-- Filter Chips Section -->
            <div class="filterSelectedChips mb-3" v-if="showfilterData.customer_name.length || showfilterData.industry_type.length || showfilterData.created_date">
                <div class="pull-right pointer resetChips" @click="removeAllChips()"><i class="icon icon-close text-white fs-20"></i></div>
                <div class="d-flex align-items-center flex-wrap">
                    <span class="font-weight-bold text-white p-2" v-show="showfilterData.customer_name.length">Customer Name</span>
                    <span v-for="(name,customer_index) in showfilterData.customer_name" :key="customer_index">
                        <span class="filterChips" @click="removeChips(name,'customer_name')">
                            {{name}}
                            <i class="icon icon-close fs-12"></i>
                        </span>
                    </span>
                    <!-- <span class="font-weight-bold text-white p-2" v-show="showfilterData.customer_type.length">Customer Type</span>
                    <span v-for="(type,type_index) in showfilterData.customer_type" :key="type_index">
                        <span class="filterChips" @click="removeChips(type,'customer_type')">
                            {{type}}
                            <i class="icon icon-close fs-12"></i>
                        </span>
                    </span> -->
                    <span class="font-weight-bold text-white p-2" v-show="showfilterData.industry_type.length">Industry Type</span>
                    <span v-for="(industry_type,industry_type_index) in showfilterData.industry_type" :key="industry_type_index">
                        <span class="filterChips" @click="removeChips(industry_type,'industry_type')">
                            {{industry_type}}
                            <i class="icon icon-close fs-12"></i>
                        </span>
                    </span>
                    <span class="font-weight-bold text-white p-2" v-show="showfilterData.created_date">Date</span>
                    <span class="filterChips" v-if="showfilterData.created_date" @click="removeChips(showfilterData.created_date,'created_date')">
                        {{showfilterData.created_date[0] +','+showfilterData.created_date[1]}}
                        <i class="icon icon-close fs-12"></i>
                    </span>

                </div>
            </div>
            <div class="d-flex justify-content-between">
               <!-- <div class="d-flex">
                    <div class='slant-tabs' :class="{'activeTab':active_tab == 'listview','new-blue':active_tab == 'listview'}" @click="switchTabs('listview')">
                        <span class="text-capitalize">List View</span>
                    </div>
                      <div class='slant-tabs ml-2' :class="{'activeTab':active_tab == 'archieve','new-blue':active_tab == 'archieve'}" @click="switchTabs('archieve')">
                        <span class="text-capitalize">Archive</span>
                    </div>
                </div> -->
                <!-- Tabs Section -->
                <div class="tabs tabs-style-shape">
                    <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                        <defs>
                            <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                        </defs>
                    </svg>
                    <nav>
                        <ul class="ml-0">
                            <li :class="{'tab-current':active_tab == 'listview'}">
                                <a href="javascript:;" @click="switchTabs('listview')" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span>List View</span>
                                </a>
                            </li>
                            <li :class="{'tab-current':active_tab == 'archieve'}">
                                <a href="javascript:;" @click="switchTabs('archieve')" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span style="border-radius: 30px 0 0 0;">Archive</span>
                                </a>
                            </li>
                            <!-- For styling we need this tag  -->
                            <li style="width: 0px !important;flex: 0 !important;">
                                <a href="#section-shape-3" style="margin: 0">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="d-flex" style="flex-grow: 1">
                    <div class="d-flex ml-4" style="flex-grow: 1;position: relative;margin-left: -20px !important;">
                        <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:8px"></i>
                        <i v-if="customers_search_key !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearch"></i>
                        <input ref="searchInput" class="w-100 placeholder-text" type="text" v-model="customers_search_key" v-debounce:500ms="searchCustomers" debounce-events="input" placeholder="Search by Customer Name" style="border-radius: 20px 20px 20px 20px; padding-left: 30px; height: 2.9em;padding-right: 10px;">
                    </div>
                </div>
            </div>
            <div v-if="customersToShowStyle == 'list'" class="table-block pt-10" style="background-color:#fff;border-top-right-radius:5px">
                <list-view-customer @selectedData="selectedData" @get_list_data="getListDataEmit" :status="active_tab == 'listview' ? 'active' : 'archived'"></list-view-customer>
            </div>
            <!-- <archieve-list-customer v-if="archieve" ></archieve-list-customer>  -->
          </div>
        <div v-show="display_filters" class="filters-background filterblock">
            <div class="scm-filters fadeInDown" :class="{'fadeInUp':hide_filters == true}">
                <filter-data  :status="active_tab == 'listview' ? 'active' : 'archived'" :showfilterData="showfilterData" @hideFilters="hideFilters" @UpdateByFilter="UpdateByFilter"></filter-data>
            </div>
        </div>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <delete-customer :selected_data='selected_data' modal_name="deleteCustomer" @deleteCustomers="deleteCustomers" @cancelDelete="cancelDelete"></delete-customer>
        <archive-modal modal_name="archiveModal" @archiveData="archiveData" @cancelArchive="cancelArchive" :active_status="active_tab == 'listview' ? 'active' : 'archived'"></archive-modal>
    </div>
</template>

<script>
import { EventBus } from '../eventBus/nav-bar-event';
import customer from "../mixins/customer"
import convert from "../mixins/convert"
import { SweetModal } from 'sweet-modal-vue';
import DeleteCustomer from "../alertModals/DeleteCustomer";
import ArchiveModal from "../alertModals/ArchiveModal";
// const ArchieveListCustomer = () => import("./ArchieveListCustomer");
const ListViewCustomer = () => import("./ListViewCustomer");
import countries from "../json/countries.json";
import { HalfCircleSpinner } from "epic-spinners";
const FilterData = () => import("../Customers/FilterData.vue");
export default {
    data() {
        return {
            success_msg: "",
            warning_msg: null,
            ajaxCallinprogress: false,
            customers_search_key: '',
            search_key: "",
            customersToShow: "Manual",
            customersToShowStyle: "list",
            limit: 10,
            count: 0,
            skip:0,
            start: 0,
            end: 0,
            total: 0,
            filter: false,
            filtersLength: 0,
            customers: [],
            selectedCustomers: [],
            customerCampaigns: [],
            contacts: [],
            productInterests: [],
            countries: countries,
            countriesCaps: [],
            referredBy: [],
            customers: [],
            filters: {
                customer_name: [],
                customer_type: [],
                industry_type: [],
                date_range: "",
            },
            showfilterData:{
                customer_name: [],
                customer_type: [],
                industry_type: [],
                created_date: ""
            },
            isLoading: {
                customercontactname: false,
                customercampaignsource: false,
                contactname: false,
                productinterests: false,
                referredby: false,
            },
            customer_type :true,
            store_column_config: [],
            active_tab: 'listview',
            add_to_list: false,
            campaigns:[],
            skip_temp:0,
            temp_total:0,
            hide_filters: false,
            display_filters: false,
            customerConfigs: [],
            selected_data: [],
            listview: true,
            archieveButton :true,
        }
    },
    mixins:[customer,convert],
    components: {
        FilterData,
        SweetModal,
        DeleteCustomer,
        HalfCircleSpinner,
        ArchiveModal,
        ListViewCustomer
    },
    methods: {
        clearSearch(){
            this.customers_search_key = ""
            if(this.active_tab == 'listview') {
                this.$refs.searchInput.focus();
                this.switchTabs('listview');
            }
            else if(this.active_tab == 'archieve') {
                this.$refs.searchInput.focus();
                this.switchTabs('archieve');
            }
        },
        getListDataEmit() {
            this.selected_data = [];
        },
        genericPermission(){

        },
        async archiveData(){
            if(this.selected_data.length){
                // console.log(this.selected_data.length)
                let params = {
                    id: this.selected_data
                }
                if(this.active_tab == 'listview' ){
                    let response = await this.moveCustomer('archive',params)
                    this.success_msg = "Customers Archived Successfully"
                } else if(this.active_tab == 'archieve') {
                    let response = await this.moveCustomer('active',params)
                    this.success_msg = "Customer Retrived Successfully"
                }
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.selected_data = []
                    this.$refs.success_modal.close();
                    EventBus.$emit("selected_data")
                    EventBus.$emit("load_customers",this.filters)
                }, 3000);
            }
        },
        cancelArchive(){
            this.selectedCustomers = []
        },
        // async retrieveCustomers(){
        //     if(this.selected_data.length){
        //         let params = {
        //             id: this.selected_data
        //         }
        //         let response = await this.moveCustomer('active',params)
        //         this.success_msg = "Customer Retrived Successfully"
        //         this.$refs.success_modal.open();
        //         setTimeout(() => {
        //             this.selected_data = []
        //             this.$refs.success_modal.close();
        //             EventBus.$emit("selected_data")
        //             EventBus.$emit("load_customers",this.filters)
        //         }, 3000);
        //     }
        // },
        selectedData(value){
            // console.log("value",value)
            this.selected_data = value

        },
        switchTabs(obj){
            if(obj == 'listview'){
                this.active_tab = 'listview'
                this.listview = true
                this.archieveButton = true
                this.selected_data = []
                localStorage.setItem("TabActive",'Listview')
                EventBus.$emit("load_data_customers",'active')
                EventBus.$emit("checked", 'checked')
                EventBus.$emit("archive_status",'archive')
                this.customers_search_key = ""

            } else if(obj == 'archieve'){
                this.active_tab = 'archieve'
                this.listview = false
                this.archieveButton = false
                this.selected_data = []
                localStorage.setItem("TabActive",'Archive')
                EventBus.$emit("load_data_customers",'archived')
                EventBus.$emit("archive_status",'retrieve')
                this.customers_search_key = ""
            }
        },
        searchCustomers() {
            EventBus.$emit("search_data_customers",this.customers_search_key)
        },
        showFilters(){
            if(this.display_filters){
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            }
            else{
                this.display_filters = true
            }
        },
        hideFilters(){
            this.hide_filters = true
            setTimeout(() => {
                this.display_filters = false
                this.hide_filters = false
            }, 500);
        },
        removeChips(value,key){
            let params = {
                value:value,
                key:key
            }
            EventBus.$emit('removechip',params)
        },
        removeAllChips(){
            this.filters = {
                customer_name: [],
                customer_status: [],
                customer_type: [],
                department_name: [],
                benach_name: [],
                date_range: "",
            }
            this.showfilterData = {
                customer_name: [],
                customer_status: [],
                customer_type: [],
                department_name: [],
                benach_name: [],
                created_date: "",
            }
            EventBus.$emit('removeAllchip')
            if(!this.display_filters) {
                EventBus.$emit("load_customers",this.filters)
            }
        },
        UpdateByFilter(params){
            this.skip = 0
            this.limit = 10
            this.showfilterData = {
                customer_name:params.value1.customer_name,
                customer_type:params.value1.customer_type,
                industry_type: params.value1.industry_type,
                created_date:params.value1.created_date
            }
            this.filters = {
                customer_name:params.value1.customer_name,
                customer_type:params.value1.customer_type,
                industry_type: params.value1.industry_type,
                date_range:params.value1.created_date
            }
            EventBus.$emit("load_customers",this.filters)
        },
        viewCustomer(id) {
            this.$router.push('/customers/viewCustomers/' + id);
        },
        editCustomer(id) {
            this.$router.push('/customers/createCustomers/' + id);
        },
        // dropdownClosed() {
        //     this.search_key = "";
        //     this.count = 0;
        // },
        customerContactNameLabel({employee_details}) {
            return `${employee_details.name}`;
        },
        contactNameLabel({employee_details}) {
            return `${employee_details.name}`;
        },
        referredByLabel({employee_details}) {
            return `${employee_details.name}`;
        },
        cloneCustomer(id) {
            localStorage.setItem("clone", id);
            this.$router.push("/createCustomers");
        },
        cancelDelete(){
            this.seleted_data = []
        },
        async getCustomers() {
            // this.ajaxCallinprogress = true;
            // let params = {
            //     filter_json: this.filters,
            //     limit: this.limit == "" || this.limit == 0 || this.limit < 0 ? 1 : this.limit,
            //     skip: this.skip,
            //     search_key: this.search_key,
            //     sort_key: this.passed_key.key,
            //     sort_value: this.passed_key.value
            // };
            // this.customers = []
            // let response = await this.getCustomerList(params)
            // this.customers = []
            // this.customers = response.response;
            // this.total = response.count;
            // this.start = this.count * this.limit + 1;
            // this.end = this.count * this.limit + this.limit < this.total ? this.count * this.limit + this.limit : this.total;
            // this.$forceUpdate()
            // this.ajaxCallinprogress = false
        },
        async deleteCustomers() {
            let params = {
                id: this.selected_data
            }
            let response = await this.deleteCustomerById('delete',params)
            this.$modal.hide("deleteCustomer");
            this.success_msg = "Customer Deleted Successfully"
            this.$refs.success_modal.open();
            setTimeout(() => {
                this.selected_data = []
                this.$refs.success_modal.close();
                EventBus.$emit("selected_data")
                EventBus.$emit("load_customers",this.filters)
            }, 3000);
        },
    },
    computed: {
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
    },
    created() {
        this.getCustomers();
        this.countries.forEach(x => {
            this.countriesCaps.push(x.toUpperCase());
        });
        if (localStorage.hasOwnProperty("draft")) {
            this.customersToShow = "Draft";
            localStorage.clear();
        }
    },
    mounted(){
        localStorage.setItem("TabActive",'Listview')
    },
    watch: {
        customersToShow: function() {
            this.getCustomers();
        },
    },
}
</script>

<style scoped>
    .team-list-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .team-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .team-list-table tbody tr td {
        background: #fff;
        padding: 13px 30px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }
    .team-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
    .type-select {
        background: #fff;
        border-radius: 30px;
        height: 2.7em;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        width: 12em;
    }
    .arrow-right {
        width: 0;
        height: 0;
        border-top: 14px solid transparent;
        border-bottom: 14px solid transparent;
        border-right: 14px solid #fff;
    }
    .filter-div {
        position: fixed;
        top: 22em;
        right: 3em;
        width: 50em;
        border-radius: 7.5px;
        z-index: 9999;
    }
    .filter-head{
        white-space: nowrap;
    }
    .filter_data{
        background: #fff;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #0d5be6;
        margin-right: 5px;
        white-space: nowrap;
        padding-left: 7px;
        padding-right: 7px;
    }
    .hot_customer{
        background: #fce5e5;
        color: #e82828;
        border: solid 1px #e82828;
        border-radius: 5px;
        padding: 6px 17px 6px 17px;
    }
    .warm_customer{
        background: #ffecd1;
        color: #ff9a06;
        border: solid 1px #ff9a06;
        border-radius: 5px;
        padding: 6px 17px 6px 17px;
    }
    .cold_customer{
        background: #c5daf8;
        color: #00448b;
        border: solid 1px #00448b;
        border-radius: 5px;
        padding: 6px 17px 6px 17px;
    }
    .scm-filters {
        height: 285px !important;
        overflow: scroll !important;
    }
    .text-ellipsis{
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 250px;
        width: 250px;
        display: block;
    }
    .hide-arrow {
        visibility: hidden;
    }
    th:hover .sorting-icon {
        visibility: visible !important;
        cursor: pointer;
    }
    .placeholder-text:focus {
        padding: 8px 9.4px 8px 30px;
        border-radius: 18px !important;
        background-color: #fff;
        border: 0.3px solid #707070 !important;
        width: 100%;
    }
    @media only screen and (max-width: 987px) {
        .margin987{
            margin-bottom: 10px !important;
        }
    }
    @media only screen and (max-width: 763px) {
        .margin763{
            margin-top: 10px !important;
        }
    }
    @media only screen and (max-width: 620px) {
        .margin620{
            margin-top: 10px !important;
        }
    }
    @media only screen and (max-width: 499px) {
        .margin499{
            margin-top: 10px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Customers/CustomerList.vue